export default __webpack_public_path__ + "static/media/closeIcon.4b71f63a.svg";